/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { zoomIconClick } from '../../../analytics';

export default (set, get, payload) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  zoomIconClick(payload);
}), false, { type: 'TRACK_ZOOM_ICON_CLICK' });
